import { endpoints, poster, fetcherGET, fetcher, deleter, patcher, fetcherSwr } from '../utils/axios';
import { useMemo } from 'react';
import useSWR from 'swr';

export function useGetOnlineConsultToken(args = {}) {
  const URL = args
    ? [endpoints.onlineConsultation.getToken, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      token: data?.data || [],
      caseStatus: data?.case_status||"active",
      isLoading: isLoading,
      tokenError: error,
      tokenValidating: isValidating,
      // rawResponse: response?.data || {},
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}